// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeveloperPlayground_playground__ZmNI3 {
    background: #050518;
}

.DeveloperPlayground_content__aKJ7w {
  text-align: center;
}

.DeveloperPlayground_title__7DUgI {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #fff;
}

.DeveloperPlayground_subtitle__RyWs4 {
  color: var(--text-secondary);
  font-size: 1.2rem;
  margin-bottom: 3rem;
}

.DeveloperPlayground_codeBlocks__i3cYM {
  display: flex;
  gap: 2rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;
  justify-content: center;
}
.DeveloperPlayground_terminal__ASeSW, .DeveloperPlayground_code__dRG8K {
  flex: 1 1;
  min-width: 300px;
  max-width: 500px;
  background: rgba(10, 15, 31, 0.9);
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(114, 43, 255, 0.2);
}

.DeveloperPlayground_terminalHeader__X6bY4, .DeveloperPlayground_codeHeader__Ly5AO {
  background: rgba(114, 43, 255, 0.1);
  padding: 0.75rem;
  display: flex;
  align-items: center;
}

.DeveloperPlayground_dots__Y-kLx {
  display: flex;
  gap: 6px;
  margin-right: 1rem;
}

.DeveloperPlayground_dots__Y-kLx span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
}

.DeveloperPlayground_dots__Y-kLx span:nth-child(1) { background: #FF5F56; }
.DeveloperPlayground_dots__Y-kLx span:nth-child(2) { background: #FFBD2E; }
.DeveloperPlayground_dots__Y-kLx span:nth-child(3) { background: #27C93F; }

.DeveloperPlayground_terminal__ASeSW code, .DeveloperPlayground_code__dRG8K pre {
  display: block;
  padding: 1.5rem;
  text-align: left;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  color: var(--text);
  white-space: pre;
}

.DeveloperPlayground_actions__Hbo-\\+ {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.DeveloperPlayground_button__qk\\+OD {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  background: rgba(114, 43, 255, 0.1);
  color: var(--text);
  text-decoration: none;
  transition: all 0.3s ease;
}

.DeveloperPlayground_button__qk\\+OD:hover {
  background: rgba(114, 43, 255, 0.2);
  transform: translateY(-2px);
}

.DeveloperPlayground_button__qk\\+OD svg {
  opacity: 0.8;
}

@media (max-width: 768px) {
  .DeveloperPlayground_title__7DUgI {
    font-size: 2rem;
  }
  
  .DeveloperPlayground_subtitle__RyWs4 {
    font-size: 1rem;
  }
  
  .DeveloperPlayground_codeBlocks__i3cYM {
    flex-direction: column;
    align-items: center;
  }
  
  .DeveloperPlayground_terminal__ASeSW, .DeveloperPlayground_code__dRG8K {
    width: 100%;
  }
  
  .DeveloperPlayground_actions__Hbo-\\+ {
    flex-direction: column;
    align-items: stretch;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/DeveloperPlayground/DeveloperPlayground.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,qDAA0B,mBAAmB,EAAE;AAC/C,qDAA0B,mBAAmB,EAAE;AAC/C,qDAA0B,mBAAmB,EAAE;;AAE/C;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wDAAwD;EACxD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":[".playground {\n    background: #050518;\n}\n\n.content {\n  text-align: center;\n}\n\n.title {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  color: #fff;\n}\n\n.subtitle {\n  color: var(--text-secondary);\n  font-size: 1.2rem;\n  margin-bottom: 3rem;\n}\n\n.codeBlocks {\n  display: flex;\n  gap: 2rem;\n  margin-bottom: 3rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.terminal, .code {\n  flex: 1;\n  min-width: 300px;\n  max-width: 500px;\n  background: rgba(10, 15, 31, 0.9);\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid rgba(114, 43, 255, 0.2);\n}\n\n.terminalHeader, .codeHeader {\n  background: rgba(114, 43, 255, 0.1);\n  padding: 0.75rem;\n  display: flex;\n  align-items: center;\n}\n\n.dots {\n  display: flex;\n  gap: 6px;\n  margin-right: 1rem;\n}\n\n.dots span {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.dots span:nth-child(1) { background: #FF5F56; }\n.dots span:nth-child(2) { background: #FFBD2E; }\n.dots span:nth-child(3) { background: #27C93F; }\n\n.terminal code, .code pre {\n  display: block;\n  padding: 1.5rem;\n  text-align: left;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  color: var(--text);\n  white-space: pre;\n}\n\n.actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  background: rgba(114, 43, 255, 0.1);\n  color: var(--text);\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\n\n.button:hover {\n  background: rgba(114, 43, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n.button svg {\n  opacity: 0.8;\n}\n\n@media (max-width: 768px) {\n  .title {\n    font-size: 2rem;\n  }\n  \n  .subtitle {\n    font-size: 1rem;\n  }\n  \n  .codeBlocks {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .terminal, .code {\n    width: 100%;\n  }\n  \n  .actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"playground": `DeveloperPlayground_playground__ZmNI3`,
	"content": `DeveloperPlayground_content__aKJ7w`,
	"title": `DeveloperPlayground_title__7DUgI`,
	"subtitle": `DeveloperPlayground_subtitle__RyWs4`,
	"codeBlocks": `DeveloperPlayground_codeBlocks__i3cYM`,
	"terminal": `DeveloperPlayground_terminal__ASeSW`,
	"code": `DeveloperPlayground_code__dRG8K`,
	"terminalHeader": `DeveloperPlayground_terminalHeader__X6bY4`,
	"codeHeader": `DeveloperPlayground_codeHeader__Ly5AO`,
	"dots": `DeveloperPlayground_dots__Y-kLx`,
	"actions": `DeveloperPlayground_actions__Hbo-+`,
	"button": `DeveloperPlayground_button__qk+OD`
};
export default ___CSS_LOADER_EXPORT___;
